import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expired", "active", "upcoming"]
  static values  = { startsOn: String, expiresOn: String }

  connect() {
    const today   = this.#localToday()
    const starts  = this.#parseDate(this.startsOnValue)
    const expires = this.#parseDate(this.expiresOnValue)

    if (expires < today) {
      this.expiredTarget.classList.remove("hidden")
    } else if (starts <= today) {
      this.activeTarget.classList.remove("hidden")
    } else {
      this.upcomingTarget.classList.remove("hidden")
    }
  }

  #localToday() {
    const d = new Date()
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
  }

  #parseDate(str) {
    const [y, m, d] = str.split("-").map(Number)
    return new Date(y, m - 1, d)
  }
}
